'use strict';

angular.module('randomization')
    .component('randomizationBlocks', {
        templateUrl: 'modules/randomization/components/blocks/content.html',
        controller: 'RandomizationBlocksController',
        bindings: {
        },
    });
